'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.spacing = undefined;

var _dictionary = require('../dictionary');

var _dictionary2 = _interopRequireDefault(_dictionary);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _require = require('../variables.json'),
    $verticalRhythmMap = _require.$verticalRhythmMap; // =============================================================================
// SPACING (Settings)
// =============================================================================
// The spacing unit and following spacing map is integral to your projects
// aesthetics and flow.
//
// Every margin, padding, and other spacing in your design should be calling the
// spacing function, referencing a mapped value.
//
// NOTE: Use these values exclusively for all spacing.
//       The only exceptions to this are unitless values or '1rem' if needed.
// -----------------------------------------------------------------------------


var spacing = exports.spacing = (0, _dictionary2.default)($verticalRhythmMap, 'Unknown spacing used in spacing function');
//# sourceMappingURL=spacing.js.map


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/utils/toolkit/settings/spacing.js